"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/geom/GeometryLayout
 */

/**
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available. Supported values are `'XY'`,
 * `'XYZ'`, `'XYM'`, `'XYZM'`.
 * @enum {string}
 */
var _default = {
  XY: 'XY',
  XYZ: 'XYZ',
  XYM: 'XYM',
  XYZM: 'XYZM'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7OztlQU1lO0VBQ2JBLEVBQUUsRUFBRSxJQURTO0VBRWJDLEdBQUcsRUFBRSxLQUZRO0VBR2JDLEdBQUcsRUFBRSxLQUhRO0VBSWJDLElBQUksRUFBRTtBQUpPLEMiLCJuYW1lcyI6WyJYWSIsIlhZWiIsIlhZTSIsIlhZWk0iXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2dlb20vR2VvbWV0cnlMYXlvdXQuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=